import { ThemeModule } from '../../front/lib/ThemeModule';
export class SliderGallery extends ThemeModule {
    constructor() {
        super(...arguments);
        this.swiper = null;
        this.gallery = null;
        this.initCbs = [];
    }
    init() {
        const swiperEl = this.querySelector('.swiper');
        if (swiperEl) {
            this.initSlider(swiperEl);
        }
    }
    afterSliderInit(callback) {
        if (this.swiper) {
            callback(this.swiper, this.gallery);
        }
        else {
            this.initCbs.push(callback);
        }
    }
    initSlider(swiperEl) {
        Promise.all([
            import('swiper'),
            import('swiper/modules'),
            import('lightgallery'),
            import('lightgallery/plugins/thumbnail'),
            import('lightgallery/plugins/zoom'),
        ]).then(([{ default: Swiper }, { Scrollbar, Navigation }, { default: lg }, { default: thumb }, { default: zoom }]) => {
            var _a;
            const swiperWrapperEl = (_a = this.root) === null || _a === void 0 ? void 0 : _a.querySelector('.swiper-wrapper');
            if (swiperWrapperEl) {
                const lgSettings = {
                    plugins: [thumb, zoom],
                    mobileSettings: {
                        controls: true,
                        showCloseIcon: true,
                        download: true,
                    },
                };
                //args?.configureLightGallery?.(lgSettings);
                this.gallery = lg(swiperWrapperEl, lgSettings);
            }
            const swiperConfig = {
                spaceBetween: 32,
                modules: [Scrollbar, Navigation],
                slidesPerView: "auto",
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                on: {
                    afterInit: (swiper) => {
                        this.initCbs = this.initCbs.filter(cb => {
                            cb(swiper, this.gallery);
                            return false;
                        });
                    },
                },
            };
            //args?.configureSwiper?.(swiperConfig);
            this.swiper = new Swiper(swiperEl, swiperConfig);
        });
    }
    get swiperInstance() {
        return this.swiper;
    }
    get galleryInstance() {
        return this.gallery;
    }
}
